import React, { useState, useRef } from 'react';
import propTypes from 'prop-types';
import { useLabels } from 'wsm-common-data';
import './Badges.scss';
import { DESKTOP, MOBILE } from '../utils/widgetInfoDefaults';

const BadgeWrapper = ({ deviceType }) => {
	const [currentBadge, setCurrentBadge] = useState(null);
	const labels = useLabels();
	const pageScrollRef = useRef(null);

	const badgeData = {
		pets: {
			name: 'pets',
			image: 'https://images.dealer.com/subaru/love-promise/SOA_Loves_Pets_Vert_2Line_Ctr.png',
			badgeLabel: 'SUBARU_LOVES_PETS',
			title: 'PETS',
			topContent: 'SUBARU_LOVES_PETS_TOP_CONTENT',
			bottomContent: 'SUBARU_LOVES_PETS_BOTTOM_CONTENT'
		},
		earth: {
			name: 'earth',
			image: 'https://images.dealer.com/subaru/love-promise/SOA_Loves_the_Earth_Vert_2Line_Ctr.png',
			badgeLabel: 'SUBARU_LOVES_THE_EARTH',
			title: 'ENVIRONMENT',
			topContent: 'SUBARU_LOVES_THE_EARTH_TOP_CONTENT',
			bottomContent: 'SUBARU_LOVES_THE_EARTH_BOTTOM_CONTENT'
		},
		learning: {
			name: 'learning',
			image: 'https://images.dealer.com/subaru/love-promise/SOA_Loves_Learning_Vert_2Line_Ctr.png',
			badgeLabel: 'SUBARU_LOVES_LEARNING',
			title: 'EDUCATION',
			topContent: 'SUBARU_LOVES_LEARNING_TOP_CONTENT',
			bottomContent: 'SUBARU_LOVES_LEARNING_BOTTOM_CONTENT'
		},
		help: {
			name: 'help',
			image: 'https://images.dealer.com/subaru/love-promise/SOA_Loves_to_Help_Vert_2Line_Ctr.png',
			badgeLabel: 'SUBARU_LOVES_TO_HELP',
			title: 'COMMUNITY',
			topContent: 'SUBARU_LOVES_TO_HELP_TOP_CONTENT',
			bottomContent: 'SUBARU_LOVES_TO_HELP_BOTTOM_CONTENT'
		},
		care: {
			name: 'care',
			image: 'https://images.dealer.com/subaru/love-promise/SOA_Loves_to_Care_Vert_2Line_Ctr_1.png',
			badgeLabel: 'SUBARU_LOVES_TO_CARE',
			title: 'HEALTH',
			topContent: 'SUBARU_LOVES_TO_CARE_TOP_CONTENT',
			bottomContent: 'SUBARU_LOVES_TO_CARE_BOTTOM_CONTENT'
		}
	};

	const handleBadgeClick = (badge) => {
		if (currentBadge && badge && currentBadge.name === badge.name)
			setCurrentBadge(null);
		else {
			if (badge && deviceType === DESKTOP) {
				window.scrollTo({
					top:
						pageScrollRef.current.offsetTop +
						pageScrollRef.current.offsetHeight,
					left: 0,
					behavior: 'smooth'
				});
			} else if (badge && deviceType === MOBILE) {
				window.scrollTo({
					top:
						window.pageYOffset +
						pageScrollRef.current.getBoundingClientRect().top,
					left: 0,
					behavior: 'smooth'
				});
			}
			setCurrentBadge(badge);
		}
	};

	const Badge = ({ name, label }) => {
		return (
			<button
				type="button"
				className={`lp-badge mx-sm-4 ${
					deviceType === MOBILE ? '' : 'w-14p'
				}`}
				onClick={() => handleBadgeClick(badgeData[name])}
			>
				<img src={badgeData[name].image} alt={labels.get(label)} />
				<p className="more-info">{labels.get('MORE_INFO')}</p>
			</button>
		);
	};

	const badgeProps = {
		label: propTypes.string.isRequired,
		name: propTypes.string.isRequired
	};

	Badge.propTypes = badgeProps;
	return (
		<div className="lp-badges">
			<h3 className="lp-badges-header">
				{labels.getHTML('WHAT_IS_LOVE_PROMISE')}
			</h3>
			<p>{labels.get('LOVE_PROMISE_BADGE_CONTENT')}</p>
			<div ref={pageScrollRef} className="lp-badge-container px-sm-4">
				{Object.keys(badgeData).map((badge) => (
					<Badge
						key={badge}
						name={badgeData[badge].name}
						label={badgeData[badge].badgeLabel}
					/>
				))}
			</div>
			{currentBadge && (
				<button
					type="button"
					className={`${
						deviceType === MOBILE
							? 'lp-badge-pop-up-mobile'
							: 'lp-badge-pop-up'
					} ${currentBadge.name}`}
					onClick={() => handleBadgeClick(null)}
				>
					<h1>{labels.get(currentBadge.title)}</h1>
					<p className="top-content">
						{labels.getHTML(currentBadge.topContent)}
					</p>
					<p className="bottom-content">
						{labels.getHTML(currentBadge.bottomContent)}
					</p>
				</button>
			)}
		</div>
	);
};

const badgeWrapperProps = {
	deviceType: propTypes.string.isRequired
};

BadgeWrapper.propTypes = badgeWrapperProps;

export default BadgeWrapper;
